<script setup>
import {
  computed,
  ref,
  reactive
} from 'vue'

import locations from './locations.vue'
import catering from './catering.vue'
import story from './story.vue'

function viewMenu() {
  window.location.href = '/menu/menu.jpg'
}


const bkmOffline = ref( false )
const spgOffline = ref( false )

const onlineOrderStartedBKM = ref( false )
const onlineOrderStartedSPG = ref( false )

function onlineOrderStart( loc ) {
  if (loc == 'spg') {
    if ( spgOffline.value ) { return }
    if ( spgOffline.value ) { return }
    onlineOrderStartedSPG.value = true
    window.location.href =
    'https://direct.chownow.com/direct/29859/locations/44182'
  } else if (loc == 'bkm') {
    if ( bkmOffline.value ) { return }
    onlineOrderStartedBKM.value = true
    window.location.href =
    'https://www.toasttab.com/little-aris-japanese-kitchen-3439-burke-mill-rd-nc-27101'
  }
  
  setTimeout( () => {
    onlineOrderStartedBKM.value = false
    onlineOrderStartedSPG.value = false  
  }, 2000 )
}

</script>

<template>
  <div id="container">
    <div id="logo">
      <img
        id="logo-image"
        src="@/images/logo.png" />
    </div>
    <div id="hero">
      <img
        id="hero-image"
        src="@/images/shrimp_aioli_no_background.png" />
    </div>

    <div
      id="order"
      @click="viewMenu">
      View Menu
    </div>
    <!-- <div id="slogan">Awesome hibachi with just a short wait.</div> -->
    <div id="slogan">
      <span style="font-size: 150%;">
        Garlic makes it better! 
      </span><br/> <br>
      Try the new <span style="color: rgba(239, 78, 76, 1); font-size: 140%; font-weight: 700;">Shrimp Aioli Japonais</span><br/>
      </div>

    <div id= "online-burke-mill" class="order-online-link" :class="{'offline-button': bkmOffline}" @click="onlineOrderStart('bkm')">
      <span v-if="!bkmOffline">
        <span v-if="!onlineOrderStartedBKM">
          Online&nbsp;Order&nbsp;-&nbsp;Winston
        </span>
        <span v-else class="ellipsis-anim"><span>.</span><span>.</span><span>.</span></span>
      </span>
      <span v-else>
        Winston - Online Order<br/>
        07-30-2026 - closed water main break.
      </span>
    </div>
    
    <div id="online-spring-garden" class="order-online-link" :class="{'offline-button': spgOffline}" @click="onlineOrderStart('spg')" >
      <span v-if="!spgOffline">
        <span v-if="!onlineOrderStartedSPG">
          Online&nbsp;Order&nbsp;-&nbsp;Greensboro
        </span>
        <span v-else class="ellipsis-anim"><span>.</span><span>.</span><span>.</span></span>
      </span>
      <span v-else>
        Greensboro - Online Order<br/>
        Currently Unavailable
      </span>
    </div>
    <div id="locations-container">
      <div id="dining-container"><!-- sets background image --></div>
      <locations :bkmOffline="bkmOffline" :spgOffline="spgOffline" />
    </div>

    <!-- <div id="catering-container">
      <div id="chef-background"></div>
      <catering />
    </div> -->

    <div id="story-container">
      <!-- <story /> -->
    </div>
  </div>
</template>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Urbanist:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto+Flex:opsz,wght@8..144,700&display=swap');
</style>

<style lang="scss" scoped>

#container {
  box-sizing: border-box;
  font-family: calibre,Helvetica Neue,helvetica,arial,sans-serif;
  overflow-y: hidden;
  overflow-x: hidden;
  // background-color: rgb(250, 247, 240);
  background-color: #f7f3e1;

}

#logo {
  position: absolute;
  left: 2%;
  top: 1%;
  width: 45%;
  z-index: 100;

  @media screen and ( min-width: 1201px ) {
    // left: 10px;
    top: 10px;
    left: calc( 50%);
    width: 350px;
    height: 163px;
    transform: translateX( calc(-50% - 280px) );
  }

}

#logo-image {
  width: 75%;
  max-width: 250px;
  min-width: 190px;
}

#hero {
  overflow: hidden;
  height: 100vh;
  width: 100vw;
}
#hero-image {
  position: relative;
  overflow-x: hidden;
  // min-width: 700px;
  min-height: 100vh;
  max-width: 1200px;
  
  left: 50%;
  transform: translateX( -50% );
  // top: -10%;
  
  
  @media screen and ( min-width: 958px) {
    // width: 100%;
    max-width: 1200px;
  }
  
  @media screen and ( min-width: 1201px) {
    max-width: 1200px;
  }
}


.offline-button {
  background-color: gray !important;
  line-height: 16px !important;
  font-weight: 100 !important;
  font-size: 80% !important;

  @media screen and ( max-width: 800px ) {
    line-height: 30px !important;
  }
}
.order-online-link {
  cursor: pointer;
  position: absolute;
  z-index: 100;
  height: 25px;

  font-size: 100%;
  color: mintcream;
  font-weight: bold;
  font-family: 'Roboto Flex', sans-serif;
  text-align: center;
  line-height: 25px;

  margin-top: 10px;
  padding: 12px 12px;
  border-radius: 10px;
  background-color: rgba(239, 78, 76, 1);
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.3);
  filter: drop-shadow(0.5px 0.5px 1px rgba(0, 0, 0, 0.3));
  
  
  @media screen and (min-width: 481px) and (max-width: 800px) {
    width: 85%;
  }
  
  @media screen and ( min-width: 801px ) {
    width: 220px;
  }



  &:hover {
    background-color: rgba(212, 31, 28, 0.85);
  }

  @media screen and (max-width: 480px) {
    padding: 12px 0;
    text-align: center;
  }

  @media screen and (min-width: 481px) and (max-width: 800px) {
    padding: 12px 15px;
  }

  @media screen and ( min-width: 801px ) {
    padding: 12px 15px;
  }

  .disabled {
    background-color: gray !important;
  }

}

#online-burke-mill {
  @media screen and (max-width: 480px) {
    bottom: calc(5% + 50px);
    left: 20px;
    right: 20px;
    padding: 8px 0;
    text-align: center;
  }

  @media screen and (min-width: 481px) and (max-width: 800px) {
    bottom: calc(5%);
    left: 50%;  
    transform: translateX( -50% );
  }
  
  @media screen and ( min-width: 801px ) {
    top: 80%;
    left: 70%;
    transform: translateX( -50% );
  }
  @media screen and ( min-width: 1801px ) {
    top: 80%;
    left: 60%;
    transform: translateX( -50% );
  }


}

#online-spring-garden {
  @media screen and (max-width: 480px) {
    bottom: calc( 5% + 100px );
    left: 20px;
    right: 20px;
    padding: 8px 0;
    text-align: center;
  }
  
  @media screen and (min-width: 481px) and (max-width: 800px) {
    bottom: calc( 5% + 80px );
    left: 50%;  
    transform: translateX( -50% );
  }
  
  @media screen and ( min-width: 801px ) {
    top: 80%;
    left: 30%;
    transform: translateX( -50% );
  }

  @media screen and ( min-width: 1801px ) {
    top: 80%;
    left: 40%;
    transform: translateX( -50% );
  }

}

#order {
  cursor: pointer;
  position: absolute;
  z-index: 100;
  font-size: 1.1rem;
  font-family: 'Roboto Flex', sans-serif;
  color: mintcream;
  text-align: center;
  border: 2px solid rgba(239, 78, 76, 1);
  border-radius: 10px;
  color: rgba(239, 78, 76, 1);

  @media screen and (max-width: 480px) {
    bottom: calc( 0% + 20px );
    left: 20px;
    right: 20px;
    padding: 8px 0 8px 0;
    text-align: center;
  }

  @media screen and (min-width: 481px) and (max-width: 800px) {
    top: calc( 6% + 10px);
    right: 30px;
    padding: 12px 25px;
    width: 100px;
  }

  @media screen and ( min-width: 801px ) {
    top: 60px;
    right: 50px;
    padding: 12px 12px;
    width: 100px;
  }

  
  @media screen and ( min-width: 1201px ) {
    top: 50px;
    left: calc( 50% + 340px );
    // left: 200px;
    transform: translateX( -50% );
  }
  
  &:hover {
    background-color: rgba(212, 31, 28, 1);
  }
}


#slogan {
  cursor: pointer;
  position: absolute;
  z-index: 99;
  font-size: 200%;
  color: #f7f3e1;
  font-weight: bold;
  font-family: 'Roboto Flex', sans-serif;
  top: 20%;
  left: 50%;
  padding: 15px 15px;
  text-align: center;
  transform: translateX( -50% );
  filter: drop-shadow( 2px 2px 3px rgba(0, 0, 0, 0.6) );
  
  @media screen and ( max-width: 350px ) {
    display: none;
  }

  @media screen and ( max-width: 480px ) {
    top: 40%;
    right: 2%;
    left: 2%;
    font-size: 200%;
    

    text-align: center;
    
    transform: translateX( 0% );
    filter: drop-shadow( 1px 1px 1px black );
  }

  @media screen and (min-width: 481px) and (max-width: 800px) {
    top: 30%;
    width: 80%;
  }

  @media screen and ( min-width: 801px ) {
    top: 30%;
    width: 80%;
  }

  @media screen and ( min-width: 1201px ) {
    top: 30%;
    width: 900px;
  }
}

#dining-container {
  position: absolute;
  width: 100%;
  min-width: 1200px;
  min-height: 100vh;

  background: url( '/images/diningroom.jpg');
  filter: brightness( 40% );

  @media screen and ( max-width: 480px ) {
    display: none;
    overflow: hidden;
  }

  @media screen and ( min-width: 481px ) and ( max-width: 800px ) {
    height: 100%;
    overflow: hidden;
  }

  @media screen and ( min-width: 801px ) and ( max-width: 1200px ) {
    background-position: 0 25%;
    height: 100%;
    overflow: hidden;
  }

  @media screen and ( min-width: 1201px) {
    height: 100%;
    overflow: hidden;
    background-position: 0 40%;
  }

  @media screen and ( max-width: 480px ) {
    max-height: 900px;
    overflow: hidden;
    height: 800px;
  }

}

#locations-container {
  position: relative;

  width: 100%;
  overflow: visible;
  display: flex;
  justify-content: center;


  @media screen and ( min-width: 481px ) and ( max-width: 800px ) {
    min-height: 100vh;
  }

  @media screen and ( min-width: 801px ) and ( max-width: 1200px ) {
    min-height: 100vh;
  }

  @media screen and ( min-width: 1201px) {
    height: 800px;
  }
}


#catering-container {
  position: relative;

  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

#chef-background {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  min-width: 1200px;
  background: url( '/images/diningroom2.jpg');
  filter: brightness( 40% );
  height: auto;

  @media screen and ( max-width: 480px ) {
    display: none;
  }

  @media screen and ( min-width: 481px ) and ( max-width: 1200px ) {
    background-position: 0 40%;
  }
}


#story-container {
  position: relative;
  bottom: 0;

}
</style>

<style>
.ellipsis-anim span {
  font-size: 140%;
    opacity: 0;
    -webkit-animation: ellipsis-dot 1s infinite;
    animation: ellipsis-dot 1s infinite;
}

.ellipsis-anim span:nth-child(1) {
    -webkit-animation-delay: 0.0s;
    animation-delay: 0.0s;
}
.ellipsis-anim span:nth-child(2) {
    -webkit-animation-delay: 0.1s;
    animation-delay: 0.1s;
}
.ellipsis-anim span:nth-child(3) {
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
}

@-webkit-keyframes ellipsis-dot {
      0% { opacity: 0; }
     50% { opacity: 1; }
    100% { opacity: 0; }
}

@keyframes ellipsis-dot {
      0% { opacity: 0; }
     50% { opacity: 1; }
    100% { opacity: 0; }
}

</style>